import React from "react";
import { useTranslation } from "react-i18next";
import { EXAMPLES } from "../technique-library/catalog";
import { findTechnique } from "../experiential/toolRegistry";
import { ToolkitItem } from "./catalog";
import { itemTitle, itemDescription } from "./TechniqueCard";

type Props = {
  item: Extract<ToolkitItem, { kind: "experiential" }>;
  patientId: string; // globally selected client (may be "")
  sessionId?: string;
  language: "en" | "hu";
  apiBaseUrl: string;
  getToken: () => Promise<string>;
  onBack: () => void;
};

export const ExperientialWorkspace: React.FC<Props> = ({
  item, patientId, sessionId, language, getToken, onBack,
}) => {
  const { t } = useTranslation();
  // Client is inherited from the global header selector — no second picker here.
  const client = patientId;
  const tool = item.techniqueKey ? findTechnique(item.techniqueKey) : undefined;
  const demo = EXAMPLES[item.code];

  return (
    <div className="tk-workspace">
      <button type="button" className="tk-back" onClick={onBack}>← {t("toolkit.back")}</button>
      <div className="tk-ws-head">
        <h2 className="tk-ws-title">{itemTitle(item, t)}</h2>
        <span className={`tk-badge tk-badge--modality tk-badge--m-${item.modality}`}>{t(`toolkit.modality.${item.modality}`)}</span>
        {item.wip && <span className="tk-badge tk-badge--wip">{t("toolkit.badgeWip")}</span>}
      </div>
      <p className="tk-ws-desc">{itemDescription(item, t)}</p>

      {item.wip || !tool ? (
        <p className="tk-ws-desc"><em>{t("toolkit.comingSoon")}</em></p>
      ) : !client ? (
        <p className="tk-ws-desc">{t("toolkit.selectClientFirst")}</p>
      ) : (
        <div className="tk-tool">
          {tool.render({ patientId: client, sessionId, language, getToken })}
        </div>
      )}

      {demo && (
        <details className="tk-example">
          <summary>{t("toolkit.seeExample")}</summary>
          <div>{demo}</div>
        </details>
      )}
    </div>
  );
};
